import type { FilterField } from "@core/components/SearchBar";

export const SORT_DIR_ASC = "asc";
export const SORT_DIR_DESC = "desc";

export const SORT_BY_KPI_NAME = "kpi_name";
export const SORT_BY_ACTIVITY_NAME = "activity_name";
export const SORT_BY_REPORT_TEMPLATE_NAME = "report_template_name";
export const SORT_BY_DEPARTMENT_NAME = "name";
export const SORT_BY_UNIT_NAME = "unit_name";
export const SORT_BY_RULE_NAME = "rule_name";
export const SORT_BY_SUB_GROUP_NAME = "name";
export const SORT_BY_DISTRICT_NAME = "district_name";
export const SORT_BY_CHURCH_NAME = "church_name";

export const SORT_BY_FNAME = "fname";
export const SORT_BY_LNAME = "lname";
export const SORT_BY_TRN = "trn";
export const SORT_BY_EMAIL = "email";
export const SORT_BY_PERSON_NAME = "name";
export const SORT_BY_ROLE = "role";

export const SORT_PARAM_KEYS = ["sortBy", "sortDir"] as const;

export const NAME_SORT_FILTER_FIELD: FilterField = {
  name: "sortDir",
  label: "Sort",
  type: "select",
  includeEmptyOption: false,
  options: [
    { value: SORT_DIR_ASC, label: "Name A–Z" },
    { value: SORT_DIR_DESC, label: "Name Z–A" },
  ],
};

export function normalizeSortDir(value: unknown): string {
  return value === SORT_DIR_DESC ? SORT_DIR_DESC : SORT_DIR_ASC;
}

export function readSortDirFromSearchParams(searchParams: URLSearchParams): string {
  return normalizeSortDir(searchParams.get("sortDir"));
}

/** Drop sort keys so they do not count as content filters (all=true / badge). */
export function filtersWithoutSort(
  filters: Record<string, any>
): Record<string, any> {
  const next = { ...filters };
  delete next.sortBy;
  delete next.sortDir;
  return next;
}

export function contentFilterKeys(keys: string[]): string[] {
  return keys.filter((key) => key !== "sortBy" && key !== "sortDir");
}

export function countContentFilters(filters: Record<string, any>): number {
  return Object.entries(filters).filter(
    ([key, value]) =>
      key !== "sortBy" &&
      key !== "sortDir" &&
      value !== undefined &&
      value !== null &&
      value !== ""
  ).length;
}

/** Ensure catalog list/picker requests always carry allowlisted name sort. */
export function withCatalogSort<T extends Record<string, any>>(
  params: T,
  sortBy: string
): T & { sortBy: string; sortDir: string } {
  return {
    ...params,
    sortBy,
    sortDir: normalizeSortDir(params.sortDir),
  };
}
